import { AnanseApiService } from "app/services/Ananse/AnanseApiService";
import { useEffect, useState } from "react";
import {
  TableRow,
  TableCell,
  Tooltip,
  Button,
  ButtonGroup,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { QuizAnswerCognitiveType } from "interfaces";
import { formatedDate } from "utils";
import Loading from "app/pages/home/components/Loading";
import { useTranslation } from "_metronic/i18n/language";
import { PatientAccountType } from "app/types";
import { useCognitiveResultModel } from "../useCognitiveResultModel";
import ModalAnswerCognitive from "../components/ModalAnswerCognitive";
import ModalCognitiveDetails from "../components/ModalCognitiveDetails";
import { showMensage } from "app/services/FeaturesElement";
import DataTable from "app/pages/admin/components/DataTable";

export type ParamsI = {
  id: number | undefined;
  name: string;
};

export type ResultQuizCognitiveType = {
  testResultId: string;
  results: QuizAnswerCognitiveType[];
};

type CognitiveResultViewType = ReturnType<typeof useCognitiveResultModel>;
const CognitiveResultView = (props: CognitiveResultViewType) => {
  const {
    findQuestion,
    getQuiz: getNameTest,
    addQuizName,
    getQuizNameByTestResultId,
    processResultCognitive,
  } = props;
  const translate = useTranslation();
  const api = new AnanseApiService();
  const params: any = useParams();
  const account: ParamsI | undefined = params;
  const [loading, setLoading] = useState<boolean>(false);
  const [results, setResults] = useState<ResultQuizCognitiveType[]>([]);
  const [resultSelected, setResultSelected] = useState<
    ResultQuizCognitiveType
  >();
  const [openModal, setOpenModal] = useState(false);
  const [openModalAnswer, setOpenModalAnswer] = useState(false);
  const [answerSelected, setAnswerSelected] = useState<
    QuizAnswerCognitiveType
  >();
  const [nameTitle, setNameTitle] = useState<string>("");
  const [accountSelected, setAccountSelected] = useState(
    {} as PatientAccountType,
  );
  const { id } = useParams<{ id: string }>();

   useEffect(() => {
    loadResults();
  }, []);

  const loadResults = async () => {
    setLoading(true);
    try {
      getAccount(Number(id));
      const reqBase = {
        method: "GET",
        url: `/quizanswercognitive/getquizanswercognitiveby/${id}`,
      };

      const result: QuizAnswerCognitiveType[] = await api.makeHttpRequest({
        ...reqBase,
      });
      result.forEach(async res => {
        const hasQuizName = getQuizNameByTestResultId(res.testResultId);
        if (res.typeQuiz === "quiz" && !hasQuizName) {
          const quizData = await getNameTest(res.quizId);
          addQuizName({ [res.testResultId]: quizData.name });
        }
      });

      const data: ResultQuizCognitiveType[] = Object.values(
        result.reduce((acc, cur) => {
          if (!acc[cur.testResultId]) {
            acc[cur.testResultId] = {
              testResultId: cur.testResultId,
              results: [{ ...cur }],
            };
          } else {
            acc[cur.testResultId].results.push(cur);
          }
          return acc;
        }, {} as Record<string, ResultQuizCognitiveType>),
      );

      const sortedResult = data.sort(
        (a: any, b: any) =>
          new Date(b.initDate).getTime() - new Date(a.initDate).getTime(),
      );

      const filterResults = sortedResult.filter(
        (ai: ResultQuizCognitiveType) => ai.results[0].answer !== "N/A",
      );
      processResultCognitive(filterResults);
      setResults(filterResults);
    } catch (error) {
      console.error("ERROR: ", error);
      showMensage(translate, false, translate("defaultMessages.loadData"));
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (isOpen: boolean) => {
    setOpenModal(isOpen);
  };

  const handleAnswerPress = (answer: QuizAnswerCognitiveType) => {
    setAnswerSelected(answer);
    setOpenModalAnswer(true);
  };

  const getAccount = async (
    accountId: number | undefined,
  ): Promise<PatientAccountType | any> => {
    try {
      const response: PatientAccountType = await api.makeHttpRequest({
        url: `/account/${accountId}`,
      });
      setAccountSelected(response);
      setNameTitle(
        translate("screenApp.anamnese.list.resultsOf") + response?.name,
      );
    } catch (error) {
      console.error("error getAccount: ", error);
    }
  };

  const headColumns = [
    { id: "none", label: translate("screens.dashboard.action") },
    { id: "title", label: translate("screens_quiz_list_title") },
    { id: "createdAt", label: translate("screenApp.results.examDate") },
    {
      id: "testResultId",
      label: translate("screenApp.results.numberTest"),
    },
    { id: "doctor", label: translate("screenApp.results.title") },
    { id: "email", label: translate("screens.login.email") },
  ];

  const gerarResultado = (value: any) => {
    setResultSelected(value);
    setOpenModal(true);
  };

  const formatRows = (result: ResultQuizCognitiveType, labelId: any) => {
    const row = result.results[0];

    return (
      <TableRow hover tabIndex={-1} key={row.id} sx={{ cursor: "pointer" }}>
        <TableCell>
          <ButtonGroup size="small" aria-label="small button group">
            <Tooltip title={translate("buttons_detail")}>
              <Button
                size="small"
                variant="contained"
                onClick={() => gerarResultado(result)}
              >
                {translate("screenApp_listPacient_buttonsPacient_buttonDetail")}
              </Button>
            </Tooltip>
          </ButtonGroup>
        </TableCell>
        <TableCell align="inherit">
          {getQuizNameByTestResultId(result.testResultId)}
        </TableCell>
        <TableCell align="inherit">
          {row.createdAt ? formatedDate(row.createdAt, true, true) : null}
        </TableCell>
        <TableCell id={labelId} align="inherit">
          {row.testResultId}
        </TableCell>
        <TableCell id={labelId} align="inherit">
          {row.doctor}
        </TableCell>
        <TableCell id={labelId} align="inherit">
          {row.email}
        </TableCell>
      </TableRow>
    );
  };

  return (
    <div
      style={{
        paddingBottom: "50px",
      }}
    >
      <Loading isLoading={loading} />

      {/* {resultSelected && (
        <ModalCognitiveDetails
          quizAnswer={resultSelected}
          openModal={openModal}
          findQuestion={findQuestion}
          setOpenModal={handleOpenModal}
          loading={loading}
          setLoading={setLoading}
          accountId={account}
          accountSelected={accountSelected}
        />
      )} */}

      {resultSelected && (
        <ModalCognitiveDetails
          quizAnswer={resultSelected}
          openModal={openModal}
          findQuestion={findQuestion}
          setOpenModal={handleOpenModal}
          loading={loading}
          setLoading={setLoading}
          accountId={account}
          accountSelected={accountSelected}
          handleAnswerPress={handleAnswerPress}
          quizName={getQuizNameByTestResultId(resultSelected.testResultId)}
        />
      )}

      {resultSelected && answerSelected && (
        <ModalAnswerCognitive
          answer={answerSelected}
          openModal={openModalAnswer}
          setOpenModal={setOpenModalAnswer}
          translate={translate}
        />
      )}
      <DataTable
        formatRows={formatRows}
        headColumns={headColumns}
        loading={loading}
        translate={translate}
        rows={results}
        placeholderSearch={
          translate("screenApp.anamnese.list.search") +
          " " +
          translate("screenApp.results.numberTest")
        }
        onRefresh={loadResults}
        router="/admin/account"
        titleTable={nameTitle}
      />
    </div>
  );
};

export default CognitiveResultView;
